import api from './api';

export const getComments   = (announcementId) => api.get(`/hub-announcement/${announcementId}/comments`).then(r => r.data.comments);
export const createComment = (announcementId, body, parentCommentId, image_url) => api.post(`/hub-announcement/${announcementId}/comments`, { body, parentCommentId, image_url }).then(r => r.data.comment);
export const deleteOwnComment = (commentId) => api.delete(`/hub-announcement/comments/${commentId}`);
